angular.module('app').directive('selectMunicipio', function() {
	return {
        restrict: 'E',
        template: function($element, attrs){
            var html = `
                <select class="form-control" 
                    chosen
                    ng-options="x.id as x.municipio for x in options" 
                    ng-model="ngModel" 
                    ng-change="localChange(); updateModel(ngModel);" 
                    ng-disabled="loadingMunicipios || ngDisabled">
                    <option value=""></value>
                </select>
            `;
            
            $jqueryElement = $(html);

            if(attrs.placeholder){
                $jqueryElement.attr('data-placeholder-text-single', "'"+attrs.placeholder+"'");
                $jqueryElement.find('option[value=""]').first().html(attrs.placeholder);
            }else{
                $jqueryElement.attr('data-placeholder-text-single', "' '");
            }

            if(attrs.required){
                $jqueryElement.attr('required', true);
            }

            return $jqueryElement[0].outerHTML;
        },
        require: 'ngModel',
        scope: {
            ngModel: '=',
            ngChange: '&',
            uf: '=?',
            loadingMunicipios: '=?',
            ngDisabled: '='
        },
        controller: function($scope, $element, $http, $timeout, $compile) {
            $scope.options = [];

            $scope.getOptions = function(){
                if($scope.uf){
                    $scope.loadingMunicipios = true;
                    var base = window.location.protocol+'//'+window.location.hostname;
                        base = base.replace('politica.', '');
                
                    $http({
                        'url': base+'/municipios/select?uf='+$scope.uf
                    }).then(function(res){
                        $scope.options = res.data;
                        $scope.loadingMunicipios = false;
                    });
                }else{
                    $scope.options = [];
                }
            }

            $scope.localChange = function(){
                $scope.municipio = $scope.getMunicipioById($scope.ngModel);
            }

            $scope.getMunicipioById = function(id){
                for(var i in $scope.options){
                    if($scope.options[i].id === id){
                        return $scope.options[i];
                    }
                }

                return {};
            }
            
        },
        link: function ($scope, $element, attrs, ctrl) {
            $scope.getOptions();

            $scope.updateModel = function(item) {
                ctrl.$setViewValue(item);
            }

            $scope.$watch('uf', function(newValue, oldValue){
                $scope.getOptions();
            });
        }
    };
})